import React from 'react';
import {Box, Grid } from '@material-ui/core';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import '../styles/bizofficer-a.css';
import {API_URL} from '../utils/EnvVars';
// import { useDispatch } from 'react-redux';
// import { selectCourse } from '../store/course.actions';
// import { setMyCourses } from '../store/mycourses.actions';
// import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setTopicTreeTest, setTopicListTest, setSmartLearning, setMockTest } from '../store/data.actions';

const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

  export default function Execute() {
	const classes = useStyles();
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	// const authResult = new URLSearchParams(window.location.search); 
	// const studentId = authResult.get('studentId');
	// const courseId = authResult.get('courseId');

	React.useEffect(() => {		
		getApiData();	
	}, []); 

	async function getApiData(){
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};
		axios.get(API_URL+'/fetchmycourses',axiosHeader)
		.then(response => {				
				if(response.data.responseTxt==="success"){
					let index = response.data.obj.length-1;
					window.localStorage.setItem("etlMyCourses", JSON.stringify(response.data.obj));
					window.localStorage.setItem("etlSelectCourse", index);
					const mydtmout = setTimeout(
						function () {
						  clearTimeout(mydtmout);
						  window.location.href='dashboard';							
						}
					  , 8000);
					///getApiDataLastOpenedCourseUpdate(response.data.obj[index].templateId);
				}
		 })
	}

	// async function getApiDataLastOpenedCourseUpdate(templateId){
	// 	axios.get(API_URL+'/templatecache?templateId='+templateId)
	// 	   .then(response => {
	// 	   ///console.log("Just Checking >> "+response.data);  
	// 	  if(response && response.data && response.data.responseTxt==="success"){

	// 				if(response.data.topicList && response.data.topicList.length>0){
	// 					window.localStorage.setItem("etlTopicList", response.data.topicList);
	// 				}else{
	// 					window.localStorage.setItem("etlTopicList", "");
	// 				}
	// 				if(response.data.keywordList && response.data.keywordList.length>0){
	// 					window.localStorage.setItem("etlKeywordList", response.data.keywordList);
	// 				}else{
	// 					window.localStorage.setItem("etlKeywordList", "");
	// 				}
	// 				if(response.data.topicTree && response.data.topicTree.length>0){
	// 					window.localStorage.setItem("etlTopicTree", response.data.topicTree);
	// 				}else{
	// 					window.localStorage.setItem("etlTopicTree", "");
	// 				}
	// 				if(response.data.topicTreeLearning && response.data.topicTreeLearning.length>0){
	// 					window.localStorage.setItem("etlTopicTreeLearning", response.data.topicTreeLearning);
	// 				}else{
	// 					window.localStorage.setItem("etlTopicTreeLearning", "");
	// 				}
	// 				if(response.data.topicListLearning && response.data.topicListLearning.length>0){
	// 					window.localStorage.setItem("etlTopicListLearning", response.data.topicListLearning);
	// 				}else{
	// 					window.localStorage.setItem("etlTopicListLearning", "");
	// 				}
	// 				if(response.data.keywordListLearning && response.data.keywordListLearning.length>0){
	// 					window.localStorage.setItem("etlKeywordListLearning", response.data.keywordListLearning);
	// 				}else{
	// 					window.localStorage.setItem("etlKeywordListLearning", "");
	// 				}
	// 				if(response.data.topicTreeTest && response.data.topicTreeTest.length>0){
	// 					window.localStorage.setItem("etlTopicTreeTest", response.data.topicTreeTest);
	// 				}else{
	// 					window.localStorage.setItem("etlTopicTreeTest", "");
	// 				}
	// 				if(response.data.topicListTest && response.data.topicListTest.length>0){
	// 					window.localStorage.setItem("etlTopicListTest", response.data.topicListTest);
	// 				}else{
	// 					window.localStorage.setItem("etlTopicListTest", "");
	// 				}
	// 				if(response.data.smartLearningJson && response.data.smartLearningJson.length>0){
	// 					window.localStorage.setItem("etlSmartLearning", response.data.smartLearningJson);
	// 				}else{
	// 					window.localStorage.setItem("etlSmartLearning", "");
	// 				}
	// 				if(response.data.mockTestJson && response.data.mockTestJson.length>0){
	// 					window.localStorage.setItem("etlMockTest", response.data.mockTestJson);
	// 				}else{
	// 					window.localStorage.setItem("etlMockTest", "");
	// 				}

	// 		  const mydtmout = setTimeout(
	// 			function () {
	// 			  clearTimeout(mydtmout);
	// 			  window.location.href='dashboard';							
	// 			}
	// 		  , 8000);
	
	// 	  } 
	
	// 	})
	//  }

	
		return (
			<div> 
				<MetaTags>
            		<title>Payment Transaction Verifying</title>
          		</MetaTags>
				
			  	<Header />	
				<LeftDrawer />
				<main className={classes.content}>
					

				<Box mt={1}>
						<Grid container spacing={2}>
							<Grid item   md={12} xs={12} style={{textAlign:'center'}}>
								<div><CheckCircleOutlineIcon style={{fontSize:60,color:'#32cd32'}} /></div>
								<h3 className="heading" style={{color:'#32cd32'}} >Payment transaction has been completed successfully.</h3>
								<h3>Just Updating</h3>
							</Grid>
						</Grid>
				</Box>				

				<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={12} xs={12} style={{textAlign:'center'}} >
									<CircularProgress /><br/>
									<span style={{fontSize:30,color:'#c51162'}} >Wait...</span><br/>
									<span style={{fontSize:14,color:'#0000FF',fontWeight:'bold'}} >It is updating payment status and fetching your courses</span>
									<br/><span style={{fontWeight:'bold'}} >Please do not close this window.</span>
								</Grid>
							</Grid>
				</Box>				



					

				</main>
				
				

			</div>
		);
 
}